// main.js
import $ from 'jquery'

require('./utils');

import './components/support-block.js';

import AppView from './views/AppView'


$(function() {
    const appView = new AppView()
    appView.render()
})
